export const OB_KEYS = {
  resetMessageList: 'resetMessageList', // 重置消息列表
  updateUserInfo: 'updateUserInfo', // 更新用户信息
  playOrder: 'playOrder', // 播放指令
  sendPlayOrderData: 'sendPlayOrderData' // 发送播放指令
};

// 观察订阅模式
class Observer {
  constructor() {
    this.events = {};
  }

  // 订阅
  on(event, handler) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(handler);
  }

  // 取消订阅
  off(event, handler) {
    if (!this.events[event]) return;
    this.events[event] = this.events[event].filter((fn) => fn !== handler);
  }

  // 通知
  emit(event, ...args) {
    if (!this.events[event]) return;
    this.events[event].forEach((fn) => fn(...args));
  }

  // 清空某事件所有订阅
  clear(event) {
    if (this.events[event]) {
      delete this.events[event];
    }
  }
}

// 单例导出
export default new Observer();
